import type { ChannelSlackGuest } from "./core/types.js";

// The Slack guests the relay returned with a channel's member roster (fetch_channel_members'
// additive `slackGuests`). Written by fetchChannelMembers, read by the @-mention scope right
// after it awaits that same read. Empty for any channel not bridged to Slack.
// ponytail: unbounded per-channel map, one small array per opened channel.
const byChannel = new Map<string, readonly ChannelSlackGuest[]>();

export function rememberChannelSlackGuests(
  channelId: string,
  guests: readonly ChannelSlackGuest[],
): void {
  byChannel.set(channelId, guests);
}

export function channelSlackGuests(channelId: string): readonly ChannelSlackGuest[] {
  return byChannel.get(channelId) ?? [];
}
